import styled from 'styled-components';
import { MobilePagination, Pagination, Stack } from '@optimus-web/core';
import { isMobile } from '../../breakpoints';

const PaginationWrapper = styled.div`
    margin-left: auto;
`;

export const withPagination =
    (WrappedComponent: $TSFixMe, AdditionalActionComponent: $TSFixMe) =>
    ({ selected, size, breakpointRange, onPageChange, ...other }: $TSFixMe) => {
        const PaginationComponent = isMobile(breakpointRange) ? MobilePagination : Pagination;
        return (
            <>
                <WrappedComponent {...other} />
                {(AdditionalActionComponent || size > 1) && (
                    <Stack distribution="space-between" itemAlignment="center">
                        {AdditionalActionComponent && <AdditionalActionComponent />}
                        <PaginationWrapper>
                            <PaginationComponent selected={selected} size={size} onClick={onPageChange} />
                        </PaginationWrapper>
                    </Stack>
                )}
            </>
        );
    };
